var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{class:_vm.cssClass,attrs:{"data-testid":"promolabel"}},[_vm._v(_vm._s(_vm.text))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }